<div class="configuration-steps-bar">
  @for (step of steps; track $index) {
  <div
      class="step-item"
      [ngClass]="{'current': currentStep === $index, 'completed': currentStep > $index}">
    <div class="step-item__number">
      <div class="step">
      </div>
      <div class="step-progress" [attr.data-test]="'link-step' + step.value"></div>
    </div>
    <button
      type="button"
      class="step-item__title"
      (click)="selectStep.emit($index)">
      {{ step.value }}
    </button>
  </div>
  }
</div>
